var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-with-subclass"},[_c('div',{staticClass:"title-with-subclass_title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"title-with-subclass_title"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]),_c('ContentChipsList',{attrs:{"chips":_vm.subclasses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }